import React, { useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Tabs as BaseTabs, Tab } from '@mui/material';
import { cx } from 'remirror';
import Icon, { IconType } from '@ui/Icon';
import { a11yPropsTab } from '.';

const useStyles = makeStyles()(theme => ({
  tab: {
    minWidth: 0,
    padding: theme.spacing(2, 1.5, 1.5),
    marginRight: theme.spacing(2),
  },
}));

export interface TabsProps<T> {
  id: string;
  className?: string;
  tabClassName?: string;
  values: Array<T>;
  icons?: Map<T, IconType>;
  onChange: (value: T) => void;
  'aria-label'?: string;
}

const Tabs = <T extends string>(props: TabsProps<T>) => {
  const {
    id,
    className,
    tabClassName,
    values,
    icons,
    'aria-label': ariaLabel,
    onChange,
  } = props;
  const { classes } = useStyles();

  const handleChange = (event: React.ChangeEvent<object>, newValue: number) => {
    setTabIndex(newValue);
    onChange(values[newValue]);
  };

  const [currentTabIndex, setTabIndex] = useState(0);

  return (
    <BaseTabs
      value={currentTabIndex}
      onChange={handleChange}
      variant="standard"
      className={className}
      aria-label={ariaLabel}
    >
      {values.map(label => {
        const iconType = icons?.has(label) && icons.get(label);
        return (
          <Tab
            key={label}
            icon={(iconType && <Icon type={iconType} />) || undefined}
            iconPosition="start"
            label={label}
            className={cx(classes.tab, tabClassName)}
            {...a11yPropsTab(id, label)}
          />
        );
      })}
    </BaseTabs>
  );
};

export default Tabs;
